<script setup>
const props = defineProps({
    field: Object,
    item: Object
});
</script>

<template>
    <input
        v-model="item.value"
        type="number"
        step="0.01"
        class="form-control form-control-sm d-inline-block w-auto"
    />
</template>